var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 10.6333H23.333C23.425 10.6333 23.5 10.7083 23.5 10.8003C23.4998 10.8922 23.4249 10.9663 23.333 10.9663H8.66699C8.57508 10.9663 8.50018 10.8922 8.5 10.8003C8.5 10.7083 8.57497 10.6333 8.66699 10.6333Z",
    stroke: "#5E72E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66698 14.6333H16.667C16.7589 14.6335 16.833 14.7084 16.833 14.8003C16.8328 14.8921 16.7587 14.9661 16.667 14.9663H8.66698C8.57507 14.9663 8.50016 14.8922 8.49999 14.8003C8.49999 14.7083 8.57496 14.6333 8.66698 14.6333Z",
    stroke: "#5E72E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 19.4666H8.66667C8.2985 19.4666 8 19.1681 8 18.8C8 18.4318 8.2985 18.1333 8.66667 18.1333H23.3333C23.7015 18.1333 24 18.4318 24 18.8C24 19.1681 23.7015 19.4666 23.3333 19.4666Z",
    fill: "#5E72E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 23.4666H8.66666C8.29849 23.4666 7.99999 23.1681 7.99999 22.8C7.99999 22.4318 8.29849 22.1333 8.66666 22.1333H16.6667C17.0348 22.1333 17.3333 22.4318 17.3333 22.8C17.3333 23.1681 17.0348 23.4666 16.6667 23.4666Z",
    fill: "#5E72E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referral-icon.2cfc59b9d705b249470b668e591e4a5a.svg";
export { ForwardRef as ReactComponent };